import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ContentContainer,
  ItemContainer,
  LoadingContainer,
  Text,
} from "./AllCategoryItemsPage.styles";
import ContentHeader from "../utils/ContentHeader";
import { getItemsByCategory } from "../../../store/slices/gift/asyncThunks";
import { useNavigate, useParams } from "react-router-dom";
import {
  selectRecipientsWithWishlists,
  selectedCategoryData,
  selectedCategoryLoading,
  selectedCategoryTitle,
} from "../../../store/slices/gift/slice";
import {
  selectGifts,
  removeGift,
  addGifts,
} from "../../../store/slices/sendGifts/slice";

import { useTranslation } from "react-i18next";
import GiftItemCard from "../../../components/GiftItemCard/GiftItemCard";
import openToast from "../../../utils/toast";
import CategoryBar from "../../../components/CategoryBar/CategoryBar";
import AppLoader from "../../../components/AppLoader";

const AllCategoryItemsPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const data = useSelector(selectedCategoryData);
  const sectionTitle = useSelector(selectedCategoryTitle);
  const selectedItems = useSelector(selectGifts);
  const { categoryId } = useParams();
  const loading = useSelector(selectedCategoryLoading);
  const toastId = useRef(null);
  const recipientsWithWishlist = useSelector(selectRecipientsWithWishlists);

  useEffect(() => {
    dispatch(
      getItemsByCategory({
        categoryId,
        page: 1,
        order: "DESC",
        sortBy: "CreatedAt",
        search: "",
      })
    );
  }, [categoryId, dispatch]);

  const handleItemClick = (id) => {
    navigate(`/admin-portal/item-detail/${id}`);
  };
  const addToItemCart = (item) => {
    let foundItem = false;

    selectedItems.forEach((data) => {
      if (data.id === item.id) {
        const itemSubcategories = data.subcategory?.map(
          (subcategory) => subcategory.valueId
        );
        const addedItemSubcategories = item.subcategoryItems?.map(
          (subcategory) => subcategory.valueId
        );

        if (
          itemSubcategories?.sort().join(",") ===
          addedItemSubcategories?.sort().join(",")
        ) {
          foundItem = true;
        }
      }
    });

    if (!foundItem) {
      if (recipientsWithWishlist[0]?.items?.length > 0) {
        if (selectedItems.length === 1) {
          openToast(
            toastId,
            "add-item-to-cart",
            "error",
            t("select-max-1-item")
          );
          return;
        }
      }

      if (
        recipientsWithWishlist[0]?.items?.length === 0 ||
        recipientsWithWishlist.length === 0
      ) {
        if (selectedItems.length === 3) {
          openToast(
            toastId,
            "add-item-to-cart",
            "error",
            t("select-max-3-items")
          );
          return;
        }
      }
      dispatch(
        addGifts({
          id: item.id,
          image: item.photoUrl,
          name: item.name,
          price: item.price,
          currency: item.currency,
          subcategory: item.subcategoryItems,
        })
      );
    } else {
      dispatch(removeGift(item.id));
    }
  };

  return (
    <>
      <CategoryBar />

      <ContentHeader
        showTitle={true}
        showBack={true}
        title={t(
          "categories." +
            [sectionTitle.toLowerCase().replace(" ", "-").replace("/", "-")]
        )}
      />
      <ContentContainer style={{ marginTop: 40 }}>
        <ItemContainer>
          {!loading ? (
            data.length > 0 ? (
              data.map((item) => (
                <GiftItemCard
                  item={item}
                  key={item.id}
                  itemDetails={() => {
                    handleItemClick(item.id);
                  }}
                  isSelected={
                    !!selectedItems.filter(
                      (selectedItem) => item.id === selectedItem.id
                    ).length
                  }
                  addToItemCart={addToItemCart}
                />
              ))
            ) : (
              <Text>{t("category-is-empty")}</Text>
            )
          ) : (
            <LoadingContainer>
              <AppLoader width={100} height={100} />
            </LoadingContainer>
          )}
        </ItemContainer>
      </ContentContainer>
    </>
  );
};

export default AllCategoryItemsPage;
